

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./VendorForgetpassword.css";

const VendorForgetpassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false
  });

  const [touched, setTouched] = useState({
    password: false,
    confirmPassword: false
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (token) {
    } else {
      setError('Invalid or missing reset link.');
    }
  }, [token]);

  const passwordsMatch = formData.password === formData.confirmPassword;
  const hasPassword = formData.password.length > 0;
  const hasConfirmPassword = formData.confirmPassword.length > 0;

  const isFormValid =
    formData.password.length >= 6 &&
    passwordsMatch &&
    token && token.trim() !== '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
    setShowErrorPopup(false);
    if (showSuccessPopup) {
      navigate('/');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setIsLoading(true);
    setError('');

    try {
      const apiUrl = `https://backend.maamaas.com/subscription/api/auth/vendor/forget-password?token=${encodeURIComponent(token)}&newPassword=${encodeURIComponent(formData.password)}`;


      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
        }
      });

      const responseText = await response.text();

      if (!response.ok) {
        // Show error popup with the error message
        setErrorMessage(responseText || 'Failed to reset password');
        setShowErrorPopup(true);
        throw new Error(responseText || 'Failed to reset password');
      }

      // Show success popup
      setShowSuccessPopup(true);
      setIsSubmitted(true);

    } catch (err) {
      // console.error('Password reset error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <h1>Reset Password</h1>
          </div>
          <div className="no-token-message">
            <span className="error-icon">!</span>
            <p>Invalid or missing reset link.</p>
            <p className="help-text">The reset link you clicked is invalid or has expired.</p>
            <button
              onClick={() => navigate('/')}
              className="request-new-link-btn"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup success-popup">
            <div className="popup-icon success-icon">✓</div>
            <h3>Success!</h3>
            <p>Your password has been reset successfully.</p>
            <button onClick={closePopup} className="popup-btn success-btn">
              OK
            </button>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {showErrorPopup && (
        <div className="popup-overlay">
          <div className="popup error-popup">
            <div className="popup-icon error-icon">!</div>
            <h3>Error</h3>
            <p>{errorMessage || 'Failed to reset password. Please try again.'}</p>
            <button onClick={closePopup} className="popup-btn error-btn">
              Try Again
            </button>
          </div>
        </div>
      )}

      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1>Reset Password</h1>
          <p>Enter your new password below</p>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          {/* Password Field */}
          <div className="form-group">
            <label htmlFor="password">
              New Password
              <span className="required">*</span>
            </label>
            <div className="input-wrapper password-field">
              <input
                type={showPassword.password ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                onBlur={() => handleBlur('password')}
                placeholder="Enter new password"
                className={touched.password && formData.password.length < 6 ? 'error' : ''}
                disabled={isLoading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => togglePasswordVisibility('password')}
                tabIndex="-1"
              >
                <i className={`fa ${showPassword.password ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
            {touched.password && formData.password.length < 6 && (
              <span className="field-error">Password must be at least 6 characters</span>
            )}
          </div>

          {/* Confirm Password Field */}
          <div className="form-group">
            <label htmlFor="confirmPassword">
              Confirm Password
              <span className="required">*</span>
            </label>
            <div className="input-wrapper password-field">
              <input
                type={showPassword.confirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                onBlur={() => handleBlur('confirmPassword')}
                placeholder="Confirm new password"
                className={
                  touched.confirmPassword && formData.confirmPassword !== '' && !passwordsMatch
                    ? 'error'
                    : touched.confirmPassword && formData.confirmPassword !== '' && passwordsMatch
                      ? 'success'
                      : ''
                }
                disabled={isLoading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => togglePasswordVisibility('confirmPassword')}
                tabIndex="-1"
              >
                <i className={`fa ${showPassword.confirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
              {/* Green tick for matching passwords */}
              {touched.confirmPassword && formData.confirmPassword !== '' && passwordsMatch && (
                <span className="validation-icon success">✓</span>
              )}
            </div>
            {touched.confirmPassword && formData.confirmPassword !== '' && !passwordsMatch && (
              <span className="field-error">Passwords do not match</span>
            )}
          </div>

          <button
            type="submit"
            className={`submit-button ${isFormValid && !isLoading ? 'active' : ''}`}
            disabled={!isFormValid || isLoading}
          >
            {isLoading ? 'Resetting Password...' : 'Reset Password'}
          </button>

          <div className="back-to-login">
            <a href="/" className="back-link">
              ← Back to Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VendorForgetpassword;